export default __webpack_public_path__ + "static/media/paperclip.8585b656.svg";